export default __webpack_public_path__ + "static/media/Card-Latitude28DegreesGlobalPlatinumMastercard.991b7f38.png";